import { ActionBase } from '../../../core/store/action/ActionBase';

export const DISABLE_ACCOUNT = '[Customer] User Disable Account';

export class DisableAccountAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = DISABLE_ACCOUNT;

  constructor(public payload: { user: { key: string, identifier: string } }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/DisableAccountAction.ts